module.exports = __webpack_public_path__ + "static/media/linkedin.318fc660.svg";